import React from 'react'
import { Button, Row } from 'react-bootstrap'
import { useNavigate } from "react-router-dom";
interface BannerProps{
  nameUser:string
}
const Index: React.FC<BannerProps> = ({ nameUser }) => {
  const navigate = useNavigate();
  
  const backToAdmin = () => {
    localStorage.removeItem('userView')
    localStorage.removeItem('nameView')
    localStorage.removeItem('viewAss')
    navigate("/admin#users");
  }

  return (
    <Row>
      <div className='d-flex justify-content-center align-items-center bg-11 py-2'>
        <p className='p-0 m-0 mx-3'>You are in viewing as <strong>{nameUser}</strong></p>
        <Button className='bg-dark' onClick={()=>backToAdmin()}>
          Back to Admin
        </Button>
      </div>
    </Row>
  )
}

export default Index